export const useGtm = (eventName, eventParams = {}) => {
	if (process.client && window.dataLayer) {
		const event = {
			event: eventName,
			...eventParams,
		};
		window.dataLayer.push(event);
	} else {
		console.warn('GTM dataLayer is not available.');
	}
};
